<template>
  <path
    d="M18 13.0002H13V18.0002C13 18.5502 12.55 19.0002 12 19.0002C11.45 19.0002 11 18.5502 11 18.0002V13.0002H6C5.45 13.0002 5 12.5502 5 12.0002C5 11.4502 5.45 11.0002 6 11.0002H11V6.00018C11 5.45018 11.45 5.00018 12 5.00018C12.55 5.00018 13 5.45018 13 6.00018V11.0002H18C18.55 11.0002 19 11.4502 19 12.0002C19 12.5502 18.55 13.0002 18 13.0002Z"
  />
</template>
